export default function navMenu() {
    const elNavIcon = document.querySelector('.js-nav-btn'),
        elMainNav = document.querySelector('.main-nav'),
        $screenMd = 1200;

    if(window.innerWidth < $screenMd) {
        elMainNav.style.display = 'flex';
    }

    elNavIcon.addEventListener('click', function H() {
        this.children[0].classList.toggle('page-header__nav-icon--active');
        elMainNav.classList.toggle('main-nav--active');
    }, true);

    elMainNav.addEventListener('click', function H(e) {
        let target = e.target;
        if(target.closest('.main-nav__item') && window.innerWidth < $screenMd) {
            elNavIcon.children[0].classList.remove('page-header__nav-icon--active');
            elMainNav.classList.remove('main-nav--active');
        }
    }, true);

    window.addEventListener('resize', () => {
        if(window.innerWidth < $screenMd) {
            elMainNav.style.display = 'flex';
        } else {
            elMainNav.style.removeProperty('display');
        }
    });
}
